import React, { useState, useContext } from 'react';
import LinkedMenu from './LinkedMenu';
import SearchBarButton from './SearchBarButton';
import { HistoryStateContext, HistoryDispatchContext } from '../providers/HistoryProvider';
import { TabStateContext } from '../providers/TabProvider';

export default function GoBackButton() {
  const [showGoBackMenu, setShowGoBackMenu] = useState(false);

  const { activeTab } = useContext(TabStateContext);
  const history = useContext(HistoryStateContext);
  const state = history[activeTab];
  const dispatch = useContext(HistoryDispatchContext);

  const handleClickGoBackOutside = () => {
    setShowGoBackMenu(false);
  }

  const handleClickGoBack = (e) => {
    setShowGoBackMenu(true);
    e.preventDefault();
  }

  const handleGoBack = () => {
    dispatch({ type: 'back', activeTab });
  }

  const handleMenuItemClick = (params) => {
    dispatch({
      type: 'select',
      activeTab,
      ...params
    });
  }

  return (
    <LinkedMenu
      className="popup-menu--rounded"
      show={showGoBackMenu}
      itemType="back"
      onClickOutside={handleClickGoBackOutside}
      onMenuItemClick={handleMenuItemClick}
    >
      <SearchBarButton disabled={!state.back.length} onClick={handleGoBack} onContextMenu={handleClickGoBack} active={showGoBackMenu}>
        <i className="icofont-arrow-left"></i>
      </SearchBarButton>
      {
        state.back.map(item => (
          <div key={item.id} className="menu-item menu-item--selectable menu-item--thin">
            <i className="icofont-earth"></i>
            <span className="menu-item__title">{item.title}</span>
          </div>
        ))
      }
      <hr className="menu-item--split-thin" />
      <div data-history className="menu-item menu-item--selectable menu-item--thin">
        <i className="icofont-earth"></i>
        <span className="menu-item__title">Show full history</span>
      </div>
    </LinkedMenu>
  )
}
